import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { primaryCTA, primaryCTATarget } from "../../lib/config";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const handlePrimary = () => {
  const t = primaryCTATarget();
  if (t.startsWith("#")) scrollTo(t);
  else window.location.assign(t);
};

export const PreLaunch = () => {
  return (
    <section
      id="pre-launch"
      data-testid="pre-launch-section"
      className="py-10 md:py-28 bg-white relative overflow-hidden"
    >
      {/* subtle diamond confetti */}
      <div className="absolute inset-0 pointer-events-none opacity-70">
        {[
          { l: "5%",  t: "12%", c: "var(--pw-pink)"   },
          { l: "10%", t: "72%", c: "var(--pw-yellow)" },
          { l: "90%", t: "20%", c: "var(--pw-green)"  },
          { l: "93%", t: "78%", c: "var(--pw-purple)" },
          { l: "50%", t: "6%",  c: "var(--pw-orange)" },
          { l: "48%", t: "94%", c: "var(--pw-blue)"   },
        ].map((d, i) => (
          <span key={i} className="absolute w-2.5 h-2.5 rounded-full" style={{ left: d.l, top: d.t, backgroundColor: d.c }} />
        ))}
      </div>

      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center relative">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="eyebrow mb-5"
        >
          Almost Ready
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-display font-black leading-[0.95] tracking-tighter"
          style={{ fontSize: "clamp(2rem, 5.6vw, 4.5rem)", color: "var(--pw-navy)" }}
        >
          Everyone people watches.
          <br />
          <span className="yellow-stroke" style={{ color: "var(--pw-navy)" }}>
            Now there&apos;s a game for it.
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-6 text-lg text-[color:var(--pw-navy)]/70 max-w-xl mx-auto leading-relaxed"
        >
          People Watching is almost ready. Join the Watch List and be one of the first to play.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-8 md:mt-10"
        >
          <button
            onClick={handlePrimary}
            data-testid="pre-launch-cta"
            className="pw-btn-primary"
          >
            {primaryCTA()} <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default PreLaunch;
